"use client";

import styles from "../styles/SchoolFeedPageWrapperHeader.module.scss";
import { observer } from "mobx-react";
import classNames from "classnames";
import { useComponentVisible } from "../../../../hooks/useComponentVisible";
import { useStores } from "../../../../stores/useStores";
import FontAwesome from "../../../utilities/FontAwesome";
import ModalBackdrop from "../../../modals/_ModalBackdrop";
import { ReactElement } from "react";
import { cssValue } from "../../../../utils/SchoolBlocksUtilities";

export const SchoolFeedPageWrapperHeaderClientMobileDropdown = observer(
  (props: { mobileMenu: ReactElement }) => {
    const { organizationStore, interfaceStore } = useStores();

    const { setIsComponentVisible, isComponentVisible } =
      useComponentVisible(false);

    const mobileMenuContainerClassName = classNames({
      [styles.mobileDropDownMenu]: true,
      [styles.mobileDropDownMenuOpen]: isComponentVisible,
    });

    const mobileChevronClassName = classNames({
      [styles.mobileChevron]: true,
      [styles.mobileChevronRotated]: isComponentVisible,
    });

    return (
      <div>
        {interfaceStore.breakpoint !== "break-point-lg" && (
          <>
            <div className={styles.mobileDropDownContainer}>
              <button
                aria-label={"Open Navigation"}
                onClick={() => setIsComponentVisible((v) => !v)}
              >
                <div>
                  {`Explore ${organizationStore.currentOrganization.title}`}
                </div>
                <div className={mobileChevronClassName}>
                  <FontAwesome prefix={"fas"} name={"fa-chevron-right"} />
                </div>
              </button>
              <div className={mobileMenuContainerClassName}>
                {props.mobileMenu}
              </div>
            </div>
            {isComponentVisible && (
              <ModalBackdrop
                active={true}
                onMouseDown={() => setIsComponentVisible(false)}
                zIndex={parseInt(cssValue("--z-index-cleverfeed-sidebar")) - 1}
              />
            )}
          </>
        )}
      </div>
    );
  },
);
